import { SiteUrls } from '@tableau/shared-urls';
import { DataGrid } from '@tableau/widgets-datagrid';

import { CommonDataGridColumns } from '../../common/react/CommonDataGridColumns';
import { IActionTarget } from '../../common/react/components/ActionsMenu';
import { DataGridCells } from '../../common/react/components/dataGrid/DataGridCells';
import { SortableHeader } from '../../common/react/components/dataGrid/SortableHeader';
import { IReactTranslateService } from '../../common/react/IReactTranslateService';
import { ISiteRoleFilter } from '../../ts/filters/SiteRoleFilter';
import { ISiteUserInfo } from '../../ts/models/ISiteUserInfo';
import { SiteRoles } from '../../ts/ServerApi/types/ISiteRole';
import { IActionButton } from '../../ts/services/ActionPanelService';

export module GroupUsersGrid {

  function isUserReadonlyOrGuest(user: ISiteUserInfo) {
    return user.readOnly || user.siteRole === SiteRoles.Guest;
  }

  export function columns(translate: IReactTranslateService,
                          scope: DataGridCells.ISelectedItemsScope<ISiteUserInfo>,
                          siteUrls: SiteUrls,
                          siteRoleFilter: ISiteRoleFilter,
                          actions: IActionButton<ISiteUserInfo, {}>[],
                          getActionTarget: () => IActionTarget<ISiteUserInfo, {}>): DataGrid.Column[] {

    const columns: DataGrid.Column[] = [
      CommonDataGridColumns.selected(scope),
      CommonDataGridColumns.withExtraSpace(CommonDataGridColumns.userDisplayNameColumn({
        actions: actions,
        getActionTarget: getActionTarget,
        linkDisabled: isUserReadonlyOrGuest,
        menuDisabled: (row: DataGrid.Row) => isUserReadonlyOrGuest(row.data as ISiteUserInfo),
        scope: scope,
        translate: translate,
        url: (user: ISiteUserInfo) => siteUrls.userContentUrl(user.username, user.domainName)
      })),
      {
        name: 'username-col',
        dataKey: 'username',
        headerText: translate('column_username'),
        headerFormatter: SortableHeader.Formatter(),
        direction: 'asc'
      },
      {
        name: 'siteRole-col',
        dataKey: 'siteRole',
        headerText: translate('column_site_role'),
        direction: 'asc',
        headerFormatter: SortableHeader.Formatter(),
        cellFormatter: DataGridCells.PlainTextCellWithTransform('siteRole',
          (siteRole: string) => siteRoleFilter(siteRole))
      },
      {
        name: 'lastSignIn-col',
        dataKey: 'lastSignIn',
        headerText: translate('column_last_sign_in'),
        direction: 'desc',
        headerFormatter: SortableHeader.Formatter(),
        cellFormatter: DataGridCells.DateTimeCell('lastSignIn')
      }
    ];

    return columns;
  }

}
